export class Search<T> {
    _lt: T;
    _lte: T;
    _gt: T;
    _gte: T;
    _contains: T;
    _: T;
    _ne: T;

    _start = 0;
    _limit = 10;
    _sort: string;

    constructor(TCreator: { new(): T; }) {
        this._lt = new TCreator();
        this._lte = new TCreator();
        this._gt = new TCreator();
        this._gte = new TCreator();
        this._contains = new TCreator();
        this._ = new TCreator();
        this._ne = new TCreator();
    }

}
